import Table from '../../../../../common/components/table';


export const EventPlansComponent = ({
    handleDelete, additionButtons, handleEdit, columnDefs, selectedEventValues,
}: any) => {

    return (
        <div className="w-full">
            <Table columnData={columnDefs} rowData={selectedEventValues}
                onEdit={handleEdit} headingName="Event Plan Details"
                additionButtons={additionButtons} onDelete={handleDelete} />
        </div>
    )
}
export default EventPlansComponent;
